<template>
        <section class="qi-logo">
            <a @click="goTo('/')" class="pointer logo">
                <img src="@/assets/qi-logo-branco.svg" alt="Logo QI"/>
            </a>
        </section>
</template>

<script>
export default {
    methods:{
        goTo( route ){
            this.$router.push(route)
        }
    }
}
</script>

<style>

</style>